const state = {
    logged_in: false,
    user_info: '',
    token: '',
    logout: '',
    esDependenciaAdmin: false,
    esEtiquetaAdmin: false,
    codigoDependencia: '',
    nombreDependencia: '',
    codigoOrganismo: '',
    nombreOrganismo: '',
    futureEtiquetas: ''
  }
  
  const getters = {
    logged_in: (state) => {
      return state.logged_in
    },
    user_info: (state) => {
      return state.user_info
    },
    token: (state) => {
      return state.token
    },
    logout: (state) => {
      return state.logout
    },
    esDependenciaAdmin: (state) => {
      return state.esDependenciaAdmin
    },
    esEtiquetaAdmin: (state) => {
      return state.esEtiquetaAdmin
    },
    codigoDependencia: (state) => {
      return state.codigoDependencia
    },
    nombreDependencia: (state) => {
      return state.nombreDependencia
    },
    codigoOrganismo: (state) => {
      return state.codigoOrganismo
    },
    nombreOrganismo: (state) => {
      return state.nombreOrganismo
    },
    futureEtiquetas: (state) => {
      return state.futureEtiquetas
    }
  }
  
  const actions = {
    logOut ({ commit }) {
      commit('setLoggedIn', false)
    }
  }
  
  const mutations = {
    setLoggedIn (state, logged) {
      state.logged_in = logged
    },
    setUserInfo (state, info) {
      state.user_info = info
    },
    setToken (state, token) {
      state.token = token
    },
    setLogOut (state, logout) {
      state.logout = logout
    },
    setEsDependenciaAdmin (state, esDependenciaAdmin) {
      state.esDependenciaAdmin = esDependenciaAdmin
    },
    setEsEtiquetaAdmin (state, esEtiquetaAdmin) {
      state.esEtiquetaAdmin = esEtiquetaAdmin
    },
    setCodigoDependencia (state, codigoDependencia) {
      state.codigoDependencia = codigoDependencia
    },
    setNombreDependencia (state, nombreDependencia) {
      state.nombreDependencia = nombreDependencia
    },
    setCodigoOrganismo (state, codigoOrganismo) {
      state.codigoOrganismo = codigoOrganismo
    },
    setNombreOrganismo (state, nombreOrganismo) {
      state.nombreOrganismo = nombreOrganismo
    },
    setFutureEtiquetas (state, futureEtiquetas) {
      state.futureEtiquetas = futureEtiquetas
    }
  }

  
  export default {
    state,
    getters,
    actions,
    mutations
  }
  